import { createSelector } from 'reselect'
import { searchItemsSectionUtil } from 'modules/section/utils/search-items'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import getItemsCountHorizontalFlatListSelect from 'utils/flat-list/get-items-count-horizontal/index.js'
import { getSearchDomainListSectionSelector } from 'modules/section/selectors/getSearchDomainList/index.js'

/**
 * Gets all the community's posts.
 * @returns {Motivation[]}
 */
function getAllCommunityPostsProductsSelector () {
  return createSelector(
    state => state && state.motivation,
    getItemsCountHorizontalFlatListSelect,
    getSearchDomainListSectionSelector({
      section: SECTIONS_NAME.MOTIVATION,
      query: 'iamagymaholic'
    }),
    (
      motivation,
      itemsCount,
      domainList
    ) =>
      searchItemsSectionUtil({
        domain: motivation,
        section: SECTIONS_NAME.MOTIVATION,
        query: 'iamagymaholic',
        isExact: true,
        domainList
      }).slice(0, itemsCount)
  )
}

export {
  getAllCommunityPostsProductsSelector
}
